/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { artifactsControllerFindAll } from "./artifactsControllerFindAll";
import { artifactsControllerFindOne } from "./artifactsControllerFindOne";
import { artifactsControllerGetDownloadUrl } from "./artifactsControllerGetDownloadUrl";
import { artifactsControllerGetFileContent } from "./artifactsControllerGetFileContent";
import { artifactsControllerGetFolderFileContent } from "./artifactsControllerGetFolderFileContent";
import { artifactsControllerGetFolderFileDownloadUrl } from "./artifactsControllerGetFolderFileDownloadUrl";
import { artifactsControllerGetNutrientConfig } from "./artifactsControllerGetNutrientConfig";
import { artifactsControllerListFolderContents } from "./artifactsControllerListFolderContents";
import { documentArtifactsControllerFindAllByDocument } from "./documentArtifactsControllerFindAllByDocument";

export function documentArtifactsService() {
  return { artifactsControllerFindAll, artifactsControllerFindOne, artifactsControllerGetFileContent, artifactsControllerGetDownloadUrl, artifactsControllerGetNutrientConfig, artifactsControllerListFolderContents, artifactsControllerGetFolderFileContent, artifactsControllerGetFolderFileDownloadUrl, documentArtifactsControllerFindAllByDocument }
}